adminApp.component('runningEventDiscoveryExports', {
    templateUrl: '/public/components/runningEventDiscoveryExports.html',
    controller: ['RunningEventDiscoveryExportsService', function(RunningEventDiscoveryExportsService)
    {
        var ctrl = this;

        ctrl.$onInit = function(){
            ctrl.setData();
        }

        ctrl.setData = function() {
             RunningEventDiscoveryExportsService.getRunningExports(function(returnedRunningExports) {
                 ctrl.runningExports = returnedRunningExports;
             });
        };

        ctrl.cancelJob = function(runningExport) {
            RunningEventDiscoveryExportsService.cancelJob(runningExport.progressId, runningExport.accountId, runningExport.adminId, function() {
                ctrl.$onInit();
            });
        };

    }]
});
